import MenuItem from "@mui/material/MenuItem";
import {FormikSelect} from "../form/FormikSelect";

/**
 * Renders a FormikSelect component for selecting the copyright type.
 *
 * @param {Object} props - The props object.
 * @param {function} props.t - The translation function.
 * @return {React.JSX.Element} The rendered FormikSelect component.
 */
export const FormikSelectCopyrightType = ({t}) => {
    const formikKey = 'copyrightType';
    return (
        <FormikSelect fullWidth={true} formikKey={formikKey} size={"small"} t={t}>
            <MenuItem value={''}>{t('copyrightTypeValueNone', '-- Ikke valgt --')}</MenuItem>
            <MenuItem value={'copyright'}>{t('copyrightTypeValueCopyright', 'Opphavsrett')}</MenuItem>
            <MenuItem value={'unknown'}>{t('copyrightTypeValueNotChosen', 'Falt i det fri')}</MenuItem>
        </FormikSelect>
    );
};